import { timePeriodFactory } from './categories';

const timePeriodReducer = (timePeriod, action) => {
    const { raceType, principalSeason, seasonsAvailable } = timePeriod.createdBy;

    if (action.type === 'raceType' && raceType !== action.value) {
        return timePeriodFactory(
            action.value,
            principalSeason,
            seasonsAvailable
        );
    }

    return timePeriod;
};

const categoriesReducer = ({ raceCategory, raceType, timePeriod }, action) => ({
    raceCategory,
    raceType,
    timePeriod: timePeriodReducer(timePeriod, action),
});

export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/course/results/reducer.js